/* nativePasskeyBootstrap — patch the WebAuthn API on iOS/Android native.
 *
 * On native Capacitor (iOS WKWebView, Android WebView), the browser's
 * `navigator.credentials.create/get` does NOT expose the platform
 * authenticator (Face ID / Touch ID / device passkey). It returns
 * `isUserVerifyingPlatformAuthenticatorAvailable() === false`, which our
 * UI shows as "جهازك لا يدعم البصمة" even on the newest iPhones.
 *
 * `@capgo/capacitor-passkey` exposes the SAME WebAuthn JS API but routes
 * the calls through the iOS `ASAuthorizationPlatformPublicKeyCredential`
 * provider (and the equivalent Android FIDO2 API). After this shim runs,
 * the existing `webauthnApi.js` code keeps working unchanged on native.
 *
 * On web (Safari, Chrome) this is a no-op — the native browser's own
 * WebAuthn is already correct. */
import { isNative } from "./platform";

export async function bootstrapNativePasskey() {
  if (!isNative()) return;
  try {
    const mod = await import("@capgo/capacitor-passkey");
    // Plugin API surface varies slightly across versions — handle both
    // the auto-shim helper and the legacy direct `setup` method.
    if (typeof mod.autoShimWebAuthn === "function") {
      mod.autoShimWebAuthn();
    } else if (mod.CapacitorPasskey?.autoShimWebAuthn) {
      mod.CapacitorPasskey.autoShimWebAuthn();
    }
  } catch (e) {
    // Plugin failed to load — fall back to whatever the WebView offers.
    // (Will likely keep showing "device not supported", but app still works.)
    // eslint-disable-next-line no-console
    console.warn("[passkey] native shim init failed:", e?.message || e);
  }
}
